import React from "react";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Avatar from "@material-ui/core/Avatar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {} from "@fortawesome/free-solid-svg-icons";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import CardHeader from "@material-ui/core/CardHeader";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardMedia from "@material-ui/core/CardMedia";
import IconButton from "@material-ui/core/IconButton";
import FavoriteIcon from "@material-ui/icons/Favorite";
import WorkIcon from "@material-ui/icons/Work";
import SchoolIcon from "@material-ui/icons/School";
import StarIcon from "@material-ui/icons/Star";
import ShareIcon from "@material-ui/icons/Share";
import Chip from '@material-ui/core/Chip';

import {
  VerticalTimeline,
  VerticalTimelineElement
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";

import {
  faFacebookSquare,
  faLinkedinIn,
  faInstagram,
  faTwitterSquare,
  faGithubSquare
} from "@fortawesome/free-brands-svg-icons";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      <Box p={3}>{children}</Box>
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`
  };
}

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper
    // width: 500,
  },
  chip: {
    margin: "0px",
  },
}));

export default function MyTabs() {
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const dataJson = {
    name: "Shubham Chhimpa",
    about: `Hello! I am a computer science engineer \.
    I like to solve problems using Technology \.
    I am leaned towards computer science and technology from my very childhood.
    I love to explore new technologies and framework's.
    I do Android development,Web Development and Deep Learning.
    
    `,
    linkedin: "https://www.linkedin.com/in/shubhamchhimpa/",
    github: "https://github.com/shubham-chhimpa",
    twitter: "https://twitter.com/shubham_chhimpa",
    facebook: "https://www.facebook.com/shubham.chhimpa.3",
    timeline: [
      {
        title: "Marudhar Engineering College",
        subtitle: "B. Tech (CSE)",
        about: `Bachelor's of Technology with specialization in Computer Science.`,
        date: "2016-2020"
      },
      {
        title: "CityDukaan",
        subtitle: "CTO",
        about: `Builded the whole Hyperlocal Ecommerce PWA with the Inventory Management system`,
        date: "2017-2018"
      },
      {
        title: "Apli.ai",
        subtitle: "Web Developer Intern",
        about: `Builded 
        1. Recruiting System \n 
        2. Question Bank System \n 
        3. Dashobard Analysis \n 
        4. Database Backend  
        `,
        date: "2019"
      }
    ],
    certificates: [
      {
        image: "1NSZj24n-UFg4pe2s-FwRi4xO73oUMj7O",
        credential:
          "https://www.coursera.org/account/accomplishments/certificate/MJACMSPU445Q",
        title: "How Google does Machine Learning",
        company: "Cousera",
        issued: "Aug 2019"
      },
      {
        image: "1k_NTkJ7cyZpdXED5sC1oSwyuxkQG2Ucf",
        credential:
          "https://www.coursera.org/account/accomplishments/certificate/VTCXLCQU55XC",
        title: "Neural Networks and Deep Learning",
        company: "Cousera",
        issued: "Jul 2019"
      },
      {
        image: "1XTfvs6r1NCxWixNH8p8u-TFgSmqHw9H2",
        credential:
          "https://drive.google.com/file/d/1XTfvs6r1NCxWixNH8p8u-TFgSmqHw9H2/view?usp=drivesdk",
        title: "Certificate of Achievement",
        company: "GirlScript Foundation",
        issued: "Jul 2019"
      },
      {
        image: "1an14PQWDvxGZfhUVw758ZuR1BgP4V4ii",
        credential: "https://www.udemy.com/certificate/UC-7Y8OD69K/",
        title: "Computer Vision with Opencv using Python",
        company: "Udemy",
        issued: "Nov 2018"
      },
      {
        image: "1N6jQBG-1HIkIhvR5RMV_YTxXVuSZIqP8",
        credential: "https://sololearn.com/Certificate/1073-4659979/pdf",
        title: "Python 3 Course",
        company: "SoloLearn",
        issued: "Jul 2018"
      },
      {
        image: "1zvLSvS0fBXXdWEHk6VZzaZBSDhHxevds",
        credential: "https://www.sololearn.com/Certificate/1068-4659979/pdf/",
        title: "Java Tutorial Course",
        company: "SoloLearn",
        issued: "May 2017"
      }
    ],

    projects: [
      
  
      {
        title: "Facial Points Detection in Javascript",
        youtubeLink: "https://www.youtube.com/embed/9Zie7wCYeGg",
        githubLink: "https://github.com/shubham-chhimpa/Facial-Points-Detection-in-Javascript-",
        date :"Jul 2019",
        techonologies : ["TensorFlow JS","Javascript","Opencv JS"]
      },
      {
        title: "Facial Points Detection ML model",
        youtubeLink: "https://www.youtube.com/embed/j40Ubx7uUEs",
        githubLink: "https://github.com/shubham-chhimpa/Facial-Points-Detection-ML-model",
        date :"Jul 2019",
        techonologies : ["TensorFlow","Python","Opencv"]
      },
      {
        title: "Hand Finger Counter ML Model",
        youtubeLink: "https://www.youtube.com/embed/mzuslW2EAso",
        githubLink: "https://github.com/shubham-chhimpa/Hand-Finger-Counter-ML-Model",
        date :"Jul 2019",
        techonologies : ["TensorFlow","Python","Opencv"]
      },
      {
        title: "CopyBoard Flutter App",
        youtubeLink: "https://www.youtube.com/embed/tYjTO16w-Bk",
        githubLink: "https://github.com/shubham-chhimpa/CopyBoard",
        date :"Jun 2019",
        techonologies : ["Flutter","Firebase"]
      },
      {
        title: "CopyBoard PWA",
        youtubeLink: "https://www.youtube.com/embed/vgGYmt1-51g",
        githubLink: "https://github.com/shubham-chhimpa/CopyBoardWeb",
        date :"Jun 2019",
        techonologies : ["Python","Django","Material Design","Firebase"]
      },
      {
        title: "Flutter Provider - Advanced State Mangement Demo",
        youtubeLink: "https://www.youtube.com/embed/WrGTIvnxExA",
        githubLink: "https://github.com/shubham-chhimpa/FlutterProviderDemo",
        date :"Jun 2019",
        techonologies : ["Flutter"]
      },
      {
        title: "PyAnimation",
        youtubeLink: "https://www.youtube.com/embed/1b3N-sQrQ7Y",
        githubLink: "https://github.com/shubham-chhimpa/PyAnimation",
        date :"May 2019",
        techonologies : ["Python"]
      },
      {
        title: "Composi Android App",
        youtubeLink: "https://www.youtube.com/embed/OdCU4V5gomA",
        githubLink: "https://github.com/shubham-chhimpa/Composi",
        date :"May 2019",
        techonologies : ["Android","Java"]
      },
      {
        title: "Simple Ecommerce PWA",
        youtubeLink: "https://www.youtube.com/embed/ugZ3myVmDAc",
        githubLink: "https://github.com/shubham-chhimpa/UpGradAssignment",
        date :"May 2019",
        techonologies : ["Python","Flask","Bootstrap"]
      },
      {
        title: "ComposiWeb PWA",
        youtubeLink: "https://www.youtube.com/embed/rrU5f4A-DuE",
        githubLink: "https://github.com/shubham-chhimpa/composiWeb",
        date :"Feb 2019",
        techonologies : ["Python","Flask","Javascript","Heroku","ComposiAi"]
      },
      {
        title: "ComposiAI Python library",
        youtubeLink: "NA",
        githubLink: "https://github.com/IOStream-OpenEnd/composiAI",
        date :"Jan 2019",
        techonologies : ["Python"]
      },
      {
        title: "Face Detection And Recognition",
        youtubeLink: "https://www.youtube.com/embed/1UdqPCkZpSM",
        githubLink: "https://github.com/shubham-chhimpa/FaceDetectionAndRecognisation",
        date :"Dec 2018",
        techonologies : ["Opencv","Python"]
      },
      {
        title: "YOLO Object Detection",
        youtubeLink: "https://www.youtube.com/embed/WHS3ARDdbsM",
        githubLink: "https://github.com/shubham-chhimpa/YOLO_object_detection_opencv_python",
        date :"Dec 2018",
        techonologies : ["Python","Opencv"]
      },
      {
        title: "Student Records Desktop App",
        youtubeLink: "NA",
        githubLink: "https://github.com/shubham-chhimpa/Student-Record",
        date :"Mar 2018",
        techonologies : ["Java","Nitrite DB","Jfoneix"]
      },
      {
        title: "Hyper Local E-commerce PWA",
        youtubeLink: "https://www.youtube.com/embed/ccqCS2axNAM",
        githubLink: "https://mymall-79091.firebaseapp.com/",
        date :"Oct 2017",
        techonologies : ["Javascript","Material Design","Bootstrap","Firebase"]
      }
    ]
  };

  const certificateArray = dataJson.certificates.map(certificate => (
    <VerticalTimelineElement
      key={certificate.image}
      className="vertical-timeline-element--education"
      date={certificate.issued}
      iconStyle={{ background: "rgb(233, 30, 99)", color: "#fff" }}
      icon={<SchoolIcon />}
    >
      <h4 className="vertical-timeline-element-title">{certificate.title}</h4>
      <h5 className="vertical-timeline-element-subtitle ">
        <Typography
          className={classes.title}
          color="textSecondary"
          gutterBottom
        >
          {certificate.company}
        </Typography>
      </h5>
      <img
        style={{
          marginTop: "16px"
        }}
        src={`https://drive.google.com/uc?export=view&id=${certificate.image}`}
        alt="certificate"
        className="my-responsive-image"
      />
      <p>
        <a href={certificate.credential} style={{ textDecoration: "None" }}>
          See Credential
        </a>
      </p>
    </VerticalTimelineElement>
  ));

  const projectArray = dataJson.projects.map(project => (
    <Grid
    spacing={3}
    container
    alignItems="center"
    direction="column"
    justify="center"
    key={project.githubLink}

  >
    <Grid
      item
      xm={12}
      sm={4}
      lg={12}
      xl={12}
      container
      alignItems="center"
      direction="column"
      justify="center"
    >
      <Box width={1 / 2} minWidth={300}>
        <Card style={{ textAlign: "center", padding: "0" }}>

       <Box width={1} minWidth={300}>
       {project.youtubeLink === "NA" ? 
        <h5> Video Not Available </h5>
          : 
          <div
            className="video"
            style={{
              position: "relative",
              paddingBottom: "56.25%" /* 16:9 */,
              paddingTop: 25,
              paddingLeft: 16,
              height: 0
            }}
          >
            <iframe
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%"
              }}
              
              title="h"
              src={project.youtubeLink}
              frameBorder="0"
              allowFullScreen
            />
          </div>
       }
        </Box>
        
         
          <CardContent>
            <Typography
              className={classes.title}
              color="textSecondary"
              gutterBottom
            >
             {project.title}
            </Typography>
         
            {project.techonologies.map(tech => (
            <Chip key={tech} label={tech} size="small"  className={classes.chip} />
            ))
            }

          </CardContent>
          <CardActions >
         
            <Typography
              color="error"
               style={{ flex: 1 ,textAlign : "start" }}
            >
              {project.date}
            </Typography>
            <IconButton onClick={() => (window.location = project.githubLink)}>
              <FontAwesomeIcon icon={faGithubSquare} size="lg" />
            </IconButton>
          </CardActions>
        </Card>
      </Box>
    </Grid>
   
  </Grid>
 
   ));

  function handleChange(event, newValue) {
    setValue(newValue);
  }

  function handleChangeIndex(index) {
    setValue(index);
  }

  return (
    <div className={classes.root}>
      <AppBar
        position="static"
        color="default"
        style={{ color: "white", backgroundColor: "black" }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          variant="fullWidth"
          aria-label="full width tabs example"
          // style={{color : "white",backgroundColor : "black"} }
        >
          <Tab label="ME" {...a11yProps(0)} />
          <Tab label="PROJECTS" {...a11yProps(1)} />
          <Tab label="CERTIFICATES" {...a11yProps(2)} />
        </Tabs>
      </AppBar>
      <SwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        <TabPanel
          value={value}
          index={0}
          dir={theme.direction}
          style={{ backgroundColor: "black" }}
        >
          <Container maxWidth="lg">
            <Grid
              spacing={3}
              container
              direction="column"
              alignItems="center"
              justify="center"
            >
              <Grid item sm={12} lg={3} xl={3}>
                <Paper
                  className={classes.paper}
                  style={{
                    paddingTop: "16px",
                    paddingBottom: "16px",
                    paddingLeft: "16px",
                    paddingRight: "16px"
                  }}
                >
                  <Avatar
                    alt="Shubham Chhimpa"
                    src="/me.jpg"
                    style={{
                      width: "200px",
                      height: "200px",
                      marginLeft: "16px",
                      marginRight: "16px"
                    }}
                  />
                  <Grid item sm={12} lg={12} xl={12}>
                    <Typography
                      style={{ textAlign: "center", marginTop: "16px" }}
                      variant="h6"
                      color="textPrimary"
                      gutterBottom
                    >
                      {dataJson.name}
                    </Typography>
                  </Grid>
                  <Grid item sm={12} lg={12} xl={12}>
                    <IconButton
                      onClick={() => (window.location = dataJson.linkedin)}
                    >
                      <FontAwesomeIcon
                        style={{}}
                        icon={faLinkedinIn}
                        size="lg"
                      />
                    </IconButton>
                    <IconButton
                      onClick={() => (window.location = dataJson.github)}
                    >
                      <FontAwesomeIcon
                        style={{}}
                        icon={faGithubSquare}
                        size="lg"
                      />
                    </IconButton>
                    <IconButton
                      onClick={() => (window.location = dataJson.twitter)}
                    >
                      <FontAwesomeIcon
                        style={{}}
                        icon={faTwitterSquare}
                        size="lg"
                      />
                    </IconButton>
                    <IconButton
                      onClick={() => (window.location = dataJson.facebook)}
                    >
                      <FontAwesomeIcon
                        style={{}}
                        icon={faFacebookSquare}
                        size="lg"
                      />
                    </IconButton>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
            <Grid
              spacing={3}
              container
              alignItems="center"
              direction="column"
              justify="center"
            >
              <Grid
                item
                xm={12}
                sm={4}
                lg={12}
                xl={12}
                container
                alignItems="center"
                direction="column"
                justify="center"
              >
                <Box width={1 / 2} minWidth={300}>
                  <Card style={{ textAlign: "center" }}>
                    <CardHeader title="ABOUT ME" />
                    <CardContent>
                      <Typography
                        className={classes.title}
                        color="textSecondary"
                        gutterBottom
                      >
                        {dataJson.about}{" "}
                      </Typography>
                    </CardContent>
                  </Card>
                </Box>
              </Grid>
            </Grid>
            <Grid item sm={12} lg={12} xl={12}>
              <Typography
                style={{
                  textAlign: "center",
                  marginTop: "36px",
                  color: "white"
                }}
                variant="h4"
                gutterBottom
              >
                TIMELINE{" "}
              </Typography>
            </Grid>
            <VerticalTimeline>
              <VerticalTimelineElement
                className="vertical-timeline-element--work"
                date={dataJson.timeline[2].date}
                iconStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
                icon={<WorkIcon />}
              >
                <h3 className="vertical-timeline-element-title">
                  {dataJson.timeline[2].title}
                </h3>
                <h4 className="vertical-timeline-element-subtitle">
                  {dataJson.timeline[2].subtitle}
                </h4>
                <p>{dataJson.timeline[2].about}</p>
              </VerticalTimelineElement>
              <VerticalTimelineElement
                className="vertical-timeline-element--work"
                date={dataJson.timeline[1].date}
                iconStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
                icon={<WorkIcon />}
              >
                <h3 className="vertical-timeline-element-title">
                  {dataJson.timeline[1].title}
                </h3>
                <h4 className="vertical-timeline-element-subtitle">
                  {dataJson.timeline[1].subtitle}
                </h4>
                <p>{dataJson.timeline[1].about}</p>
              </VerticalTimelineElement>

              <VerticalTimelineElement
                className="vertical-timeline-element--education"
                date={dataJson.timeline[0].date}
                iconStyle={{ background: "rgb(233, 30, 99)", color: "#fff" }}
                icon={<SchoolIcon />}
              >
                <h3 className="vertical-timeline-element-title">
                  {dataJson.timeline[0].title}
                </h3>
                <h4 className="vertical-timeline-element-subtitle">
                  {dataJson.timeline[0].subtitle}
                </h4>
                <p>{dataJson.timeline[0].about}</p>
              </VerticalTimelineElement>

              <VerticalTimelineElement
                iconStyle={{ background: "rgb(16, 204, 82)", color: "#fff" }}
                icon={<StarIcon />}
              />
            </VerticalTimeline>
          </Container>
        </TabPanel>
        <TabPanel
          value={value}
          index={1}
          dir={theme.direction}
          style={{ backgroundColor: "black" }}
        >
          <Container maxWidth="lg">
           {projectArray}
          </Container>
        </TabPanel>
        <TabPanel
          value={value}
          index={2}
          dir={theme.direction}
          style={{ backgroundColor: "black" }}
        >
          <Container maxWidth="lg">
            <VerticalTimeline>
              {certificateArray}

              <VerticalTimelineElement
                iconStyle={{ background: "rgb(16, 204, 82)", color: "#fff" }}
                icon={<StarIcon />}
              />
            </VerticalTimeline>
          </Container>
        </TabPanel>
      </SwipeableViews>
    </div>
  );
}
